/**
 * Navigation Module
 * Handles navigation highlighting
 */

export function initNavigation() {
    const navLinks = document.querySelectorAll('.nav-link');

    // Remove active class from all links
    function clearActiveLinks() {
        navLinks.forEach(link => link.classList.remove('active'));
    }

    // Add click event listeners
    navLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const targetId = link.getAttribute('href').slice(1);
            const targetSection = document.getElementById(targetId);
            
            if (targetSection) {
                // Clear any active links first
                clearActiveLinks();
                // Add active class to clicked link
                link.classList.add('active');
                
                // Smooth scroll to section
                targetSection.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        });
    });

    // Remove highlighting when at top of page
    window.addEventListener('scroll', () => {
        if (window.scrollY === 0) {
            clearActiveLinks();
        }
    });
} 